import { fetchWithAuth } from '../helpers';

const API = process.env.REACT_APP_API_URL;
const HEADERS = { 'ngrok-skip-browser-warning': '69420', 'Content-Type': 'application/json' };

const handleResponse = (response: Response) =>
  response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });

// Public (no auth)
const getById = async (id: number) => {
  const resp = await fetch(`${API}/api/review-sessions/${id}`, {
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(resp);
};

const getItems = async (sessionId: number) => {
  const resp = await fetch(`${API}/api/review-sessions/${sessionId}/items`, {
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(resp);
};

// Auth required
const getAll = async () => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions`, {
    method: 'GET',
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(resp);
};

const createFromDiary = async (diaryId: number) => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions/from-diary/${diaryId}`, {
    method: 'POST',
    headers: HEADERS,
  });
  return handleResponse(resp);
};

const rebuildFromDiary = async (diaryId: number) => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions/rebuild-diary/${diaryId}`, {
    method: 'POST',
    headers: HEADERS,
  });
  return handleResponse(resp);
};

const updateSession = async (id: number, name: string) => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions/${id}`, {
    method: 'PUT',
    headers: HEADERS,
    body: JSON.stringify({ name }),
  });
  return handleResponse(resp);
};

const deleteSession = async (id: number) => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions/${id}`, {
    method: 'DELETE',
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(resp);
};

const addItem = async (sessionId: number, item: { type: string; front: string; back: string; phonetic?: string }) => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions/${sessionId}/items`, {
    method: 'POST',
    headers: HEADERS,
    body: JSON.stringify(item),
  });
  return handleResponse(resp);
};

const updateItem = async (itemId: number, data: { type?: string; front?: string; back?: string; phonetic?: string }) => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions/items/${itemId}`, {
    method: 'PUT',
    headers: HEADERS,
    body: JSON.stringify(data),
  });
  return handleResponse(resp);
};

const deleteItem = async (itemId: number) => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions/items/${itemId}`, {
    method: 'DELETE',
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(resp);
};

// Student: get sessions for my class (auto-resolved from token)
const getMyReviewSessions = async () => {
  const resp = await fetchWithAuth(`${API}/api/review-sessions/my-sessions`, {
    method: 'GET',
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(resp);
};

// Public: get sessions by classId
const getByClass = async (classId: number) => {
  const resp = await fetch(`${API}/api/review-sessions/by-class/${classId}`, {
    headers: { 'ngrok-skip-browser-warning': '69420' },
  });
  return handleResponse(resp);
};

export const reviewSessionService = {
  getById,
  getItems,
  getAll,
  getMyReviewSessions,
  getByClass,
  createFromDiary,
  rebuildFromDiary,
  updateSession,
  deleteSession,
  addItem,
  updateItem,
  deleteItem,
};
